import type { ListResponse } from '../../goodstack'

import type { InfiniteQueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { GetCampaignOrganisationsQueryParams, CampaignOrganisation } from './getCampaignOrganisations.types'

export const getCampaignOrganisations: InfiniteQueryFn<
  [string, GetCampaignOrganisationsQueryParams],
  string,
  ListResponse<CampaignOrganisation>
> = async (client, [_, { campaignId, direction = 'ASC', pageSize = 25 }], cursor) =>
  (
    await (cursor
      ? client.get<ListResponse<CampaignOrganisation>>(cursor, {
          withCredentials: true
        })
      : client.get<ListResponse<CampaignOrganisation>>(`v1/giving-campaign/${campaignId}/organisations`, {
          params: { direction, pageSize },
          withCredentials: true
        }))
  ).data
